import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { CATEGORY_QUERY } from '../../queries/CATEGORY_QUERY';

/**
 * Retrieves all of the information needed for a single category.
 */
export function useCategoryDetailsQuery( categoryId, options = {} ) {

    const { data: category, loading, error } = useQuery( CATEGORY_QUERY, {
        variables: {
            categoryId
        },
        ...options
    } );

    return useMemo ( () => {
        return {
            data: category?.category,
            loading,
            error,
        };
    }, [ category, loading, error ] );
}
